export enum CheckpointStatusOrbsEnum {
    error = 'check-status-error',
    warning = 'check-status-warning',
    alert = 'check-status-alert',
    success = 'check-status-success',
    inactive = 'check-status-inactive',
    disabled = 'check-status-disabled',
}
